import { useReducer, useCallback } from 'react';

function reducer(state, action) {
  switch (action.type) {
    case 'ON-CHANGE':
      return {
        ...state,
        [action.target.name]: action.target.value,
      };
    case 'SET-VALUE':
      return {
        ...state,
        [action.name]: action.value,
      };
    case 'SET-VALUE-ALL':
      return {
        ...state,
        [action.name]: action.value,
      };
    default:
      throw new Error();
  }
}

export default function Reducer(defaultValue) {
  const [state, dispatch] = useReducer(reducer, defaultValue);
  const onChange = useCallback((e) => {
    dispatch({ type: 'ON-CHANGE', target: e.target });
  }, []);
  const setValue = useCallback(({ name, value }) => {
    dispatch({ type: 'SET-VALUE', name: name, value: value });
  }, []);
  const setValueAll = useCallback(({ object }) => {
    Object.keys(object).forEach(function (key) {
      dispatch({ type: 'SET-VALUE-ALL', name: key, value: object[key] });
    });
  }, []);
  return [state, setValue, onChange, setValueAll];
}
